import { decodeJwtSub } from '../../../../utils/authentication';
import { useAuthData } from '../../../AuthContext/hooks/useAuthData';
import { useResolveReturnUrl } from '../useResolveReturnUrl';

export const useReturnUrl = (
  loginPath: string,
  adminPath: string,
  authPath?: string,
  pathsToIgnore: readonly string[] = [],
): string => {
  const resolve = useResolveReturnUrl(
    loginPath,
    adminPath,
    authPath,
    pathsToIgnore,
  );
  const tokens = useAuthData();

  return resolve(tokens?.jwt ? decodeJwtSub(tokens.jwt) : undefined);
};
